import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';

const STATUS_MAP: Record<string, ChipProps['color']> = {
  Active: 'success',
  Inactive: 'default',
  Locked: 'error',
  Draft: 'default',
  Submitted: 'warning',
  Pending: 'warning',
  'Pending QC': 'warning',
  'Pending Approval': 'warning',
  Approved: 'success',
  Rejected: 'error',
  Completed: 'success',
  'In Transit': 'info',
  Discrepancy: 'error',
  'Pending QA': 'warning',
  'QC Hold': 'error',
  Delayed: 'error',
  'On Time': 'success',
  Cancelled: 'default',
  PendingQc: 'warning',
  PendingPutaway: 'info',
  Passed: 'success',
  Failed: 'error',
  Hold: 'error',
  Rework: 'warning',
  PendingApproval: 'warning',
  PickListGenerated: 'info',
  Assigned: 'info',
  InProgress: 'info',
  ShortPicked: 'warning',
  Picked: 'success',
  Loaded: 'success',
  Posted: 'success',
  InTransit: 'info',
  PartiallyReceived: 'warning',
  Partial: 'warning',
  Received: 'success',
  Closed: 'default',
};

interface StatusChipProps {
  status: string;
  size?: ChipProps['size'];
}

export default function StatusChip({ status, size = 'small' }: StatusChipProps) {
  return <Chip label={status} color={STATUS_MAP[status] ?? 'default'} size={size} />;
}
